import React from 'react';
import PageShell from '../PageShell';

const ProspectsShell = ({ title = 'Prospects', subtitle, action, children }) => (
  <PageShell title={title} subtitle={subtitle} actions={action}>
    {children}
  </PageShell>
);

export default ProspectsShell;
